/*
  L'incisione, in una finestra sua (Anthony, 1 ottobre 2026).

  Nella scheda resta un campo nascosto, properties[L'incisione], che porta il
  testo all'ordine. Il bottone "Aggiungi un'incisione" (e ogni altro elemento
  con data-incisione-apri, anche fuori dal riquadro d'acquisto) apre la
  finestra: il testo scritto compare come inciso sulla fotografia del
  metallo, il contatore conta fino a venti, e la presa d'atto è obbligatoria
  solo quando c'è qualcosa da incidere. Conferma scrive il campo nascosto e
  mostra il testo nella scheda; Togli lo cancella.

  Ogni testo visibile arriva dal Liquid: qui dentro non si scrive una parola.
*/

(function () {
  'use strict';

  var modale = document.querySelector('[data-incisione-modale]');
  var valore = document.querySelector('[data-incisione-valore]');
  if (!modale || !valore || typeof modale.showModal !== 'function') return;

  var campo = modale.querySelector('[data-incisione-campo]');
  var anteprima = modale.querySelector('[data-incisione-anteprima]');
  var contatore = modale.querySelector('[data-incisione-contatore]');
  var reso = modale.querySelector('[data-incisione-reso]');
  var errore = modale.querySelector('[data-incisione-errore]');
  var conferma = modale.querySelector('[data-incisione-conferma]');
  var scelta = document.querySelector('[data-incisione-scelta]');
  var sceltaTesto = document.querySelector('[data-incisione-scelta-testo]');
  var togli = document.querySelector('[data-incisione-togli]');
  var apriTesto = document.querySelector('[data-incisione-apri-testo]');

  var modello = contatore ? contatore.getAttribute('data-modello') || '@n/@tot' : '@n/@tot';
  var esempio = anteprima ? anteprima.getAttribute('data-esempio') || '' : '';
  var totale = campo && campo.maxLength > 0 ? campo.maxLength : 20;
  var daRimettere = null;
  var primoCarattere = false;

  function misura(nome, dettaglio) {
    if (!window.Daymonilia || typeof window.Daymonilia.misura !== 'function') return;
    try { window.Daymonilia.misura(nome, dettaglio); } catch (e) { /* la misura non ferma mai l'incisione */ }
  }

  function pulito(testo) {
    return String(testo || '').replace(/^\s+|\s+$/g, '');
  }

  function aggiorna() {
    var testo = campo ? campo.value : '';
    var pieno = pulito(testo) !== '';
    if (contatore) contatore.textContent = modello.replace('@n', String(testo.length)).replace('@tot', String(totale));
    if (anteprima) {
      anteprima.textContent = pieno ? testo : esempio;
      anteprima.classList.toggle('e-esempio', !pieno);
    }
    if (errore && (!pieno || (reso && reso.checked))) errore.hidden = true;
    if (pieno && !primoCarattere) {
      primoCarattere = true;
      misura('incisione_input', { lunghezza: testo.length });
    }
  }

  function scriviScelta() {
    var testo = pulito(valore.value);
    if (scelta) scelta.hidden = !testo;
    if (sceltaTesto) sceltaTesto.textContent = testo ? '«' + testo + '»' : '';
    if (togli) togli.hidden = !testo;
    if (apriTesto) {
      apriTesto.textContent = testo
        ? apriTesto.getAttribute('data-testo-modifica')
        : apriTesto.getAttribute('data-testo-aggiungi');
    }
  }

  function apri(evento) {
    if (evento) evento.preventDefault();
    daRimettere = document.activeElement;
    if (campo) campo.value = valore.value;
    if (reso) reso.checked = pulito(valore.value) !== '';
    aggiorna();
    modale.showModal();
    if (campo) campo.focus();
    misura('incisione_apri');
  }

  function chiudi() {
    if (modale.open) modale.close();
  }

  modale.addEventListener('close', function () {
    if (daRimettere && typeof daRimettere.focus === 'function') daRimettere.focus();
    daRimettere = null;
  });

  /* Un clic sul velo, fuori dalla finestra, chiude senza cambiare niente. */
  modale.addEventListener('click', function (evento) {
    if (evento.target === modale) chiudi();
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-incisione-apri]'), function (bottone) {
    bottone.addEventListener('click', apri);
  });

  Array.prototype.forEach.call(modale.querySelectorAll('[data-incisione-chiudi]'), function (bottone) {
    bottone.addEventListener('click', chiudi);
  });

  if (campo) {
    campo.addEventListener('input', aggiorna);
    campo.addEventListener('keydown', function (evento) {
      if (evento.key === 'Enter') {
        evento.preventDefault();
        if (conferma) conferma.click();
      }
    });
  }

  if (reso) {
    reso.addEventListener('change', function () {
      if (reso.checked && errore) errore.hidden = true;
    });
  }

  if (conferma) {
    conferma.addEventListener('click', function () {
      var testo = pulito(campo ? campo.value : '');
      if (testo && reso && !reso.checked) {
        if (errore) errore.hidden = false;
        reso.focus();
        return;
      }
      valore.value = testo;
      scriviScelta();
      if (testo) misura('incisione_conferma', { lunghezza: testo.length });
      chiudi();
    });
  }

  if (togli) {
    togli.addEventListener('click', function () {
      valore.value = '';
      scriviScelta();
    });
  }

  scriviScelta();
})();
